import PropTypes from 'prop-types'

const Logomark = ({ style, fill }) => {
  return (
         <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 512 512" role="img" aria-label="Roerich Chintamani symbol">
	    <desc>Three primary-colored circles inside a green ring.</desc>
	    <circle cx="256" cy="256" r="210" fill="none" stroke="#3BAA3B" stroke-width="44" stroke-linecap="round"/>
	    <circle cx="256" cy="182" r="66" fill="#1E6DEB"/>
	    <circle cx="190" cy="302" r="66" fill="#E53935"/>
	    <circle cx="322" cy="302" r="66" fill="#F2C200"/>
	  </svg>
  )
}

Logomark.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string
}

export default Logomark
